import React from "react";
import { Link } from "react-router-dom";

/**
 * Static seller payment / escrow explanation (shown on Terms & Conditions).
 */
const SellerPaymentsTermsSection = () => (
  <section
    id="seller-payments"
    className="mt-10 rounded-xl border border-[#d8e7da] bg-[#f7faf7] p-6 text-[#333]"
    aria-labelledby="seller-payments-heading"
  >
    <h2 id="seller-payments-heading" className="text-xl font-semibold text-[#2f4232] mb-3">
      Seller payments and escrow
    </h2>
    <p className="text-sm text-slate-600 mb-4">
      If you sell on Veteran Airsoft, the following applies to how customer payments, fees, and
      your earnings are handled.
    </p>
    <h3 className="text-base font-semibold text-[#2f4232] mb-2">How payments are separated</h3>
    <ul className="list-disc space-y-2 pl-5 text-sm leading-relaxed">
      <li>
        Customer card and Klarna payments go to the <strong>Veteran Airsoft</strong> Stripe account
        first — not your personal Stripe account.
      </li>
      <li>
        <strong>Buyer protection</strong> and <strong>seller platform fees</strong> belong to Veteran
        Airsoft. They are not part of your seller earnings.
      </li>
      <li>
        Your product and postage share is held in <strong>escrow on Veteran Airsoft</strong> until the
        buyer confirms delivery. There is no separate escrow balance in Stripe for sellers.
      </li>
      <li>
        After escrow is released, your share moves to your <strong>available wallet balance</strong>.
        When you withdraw, only that amount is sent to your bank via Stripe Connect.
      </li>
    </ul>
    <p className="mt-4 text-sm text-slate-600">
      Your wallet shows your available balance and any orders still in escrow. Outstanding escrow
      amounts are calculated per order and may change until the buyer confirms receipt or the
      automatic release period ends.
    </p>
    <p className="mt-3 text-sm text-slate-600">
      Sellers must complete Stripe Connect onboarding before withdrawing to a bank account.
    </p>
  </section>
);

export default SellerPaymentsTermsSection;
